import { UserSettingsModel } from './models/index'
import { UserSettingsState } from './types'

export const state: UserSettingsState = {
  currentUserSettings: {
    featureSwitches: [],
    emailMfaEnabled: null,
  } as UserSettingsModel,
  currentUserPermissions: [],
}